<template>
    <IntegrationStoreSettingsLayout @save="saveAndContinue" @cancel="preventLeavingWithUnsavedChanges">
        <FormGroupNew label="Directory"
                      description="Specify the target directory on the FTP server."
                      :error="config.errors.opentrans_output_directory"
                      :required="requiredFields.includes('opentrans_output_directory')">
            <input class="form-control"
                   type="text"
                   placeholder="Output directory"
                   v-model="config.opentrans_output_directory"
            >
        </FormGroupNew>
    </IntegrationStoreSettingsLayout>
</template>

<script>
import IntegrationStoreSettingsLayout from "@layouts/IntegrationStoreSettingsLayout.vue";
import IntegrationStoreConfigMixin from "@mixins/IntegrationStoreConfigMixin";
import FormErrors from "@components/Form/FormErrors.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";

export default {
    components: {FormGroupNew, FormErrors, IntegrationStoreSettingsLayout},

    mixins: [IntegrationStoreConfigMixin],
}
</script>
